import { render, staticRenderFns } from "./PriorityCard.vue?vue&type=template&id=09de98e8&scoped=true"
import script from "./PriorityCard.vue?vue&type=script&lang=js"
export * from "./PriorityCard.vue?vue&type=script&lang=js"
import style0 from "./PriorityCard.vue?vue&type=style&index=0&id=09de98e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09de98e8",
  null
  
)

export default component.exports